export class AnimationEvent {
    constructor() {
    }
}
